import { render, staticRenderFns } from "./customer_device_address_select.vue?vue&type=template&id=e2f96dac&"
import script from "./customer_device_address_select.vue?vue&type=script&lang=js&"
export * from "./customer_device_address_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports